import { render, staticRenderFns } from "./details.vue?vue&type=template&id=eb7aed7e&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=eb7aed7e&scoped=scoped&lang=scss&"
import style1 from "./details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7aed7e",
  null
  
)

export default component.exports